import { wait } from '../common'
const ajaxWait = 0

const slider = document.querySelector('.vp-block-form-meetings.layout-slider')
const dom = {
  serverMessage: '.server-message',
  step1: '#meetings-step-1',
  step2: '#meetings-step-2',
  step3: '#meetings-step-3',
  step4: '#meetings-step-4',
  titleDynamic: ['.title.dynamic'],
  process2: '#meetings-step-2 .process',
  process3: '#meetings-step-3 .process',
  lieu: '#meetings-lieu',
  meetingId: '#meetings-id',
  meetingList: '#meetings-list',
  meetingListAll: ['.meetings-list'],
  meetingInternationalList: '#meetings-international-list',
  meetingInternationalListAll: ['.meetings-international-list'],
  // meetingSelects: ['select.meeting'],
  email: '#meetings-email',
  tel: '#meetings-tel',
  contact_id: '#meetings-contact_id',
  nom: '#meetings-nom',
  prenom: '#meetings-prenom',
  cp: '#meetings-cp',
  pays: '#meetings-pays',
  statut: '#meetings-statut',
  connus: '#meetings-connus',
  rgpd: '#meetings-rgpd',
  newom: '#meetings-newom',
  newsletter: '#meetings-newsletter',
}

if (slider) {
  for (const [k, v] of Object.entries(dom)) {
    if (typeof v === 'string') dom[k] = slider.querySelector(v)
    if (Array.isArray(v)) dom[k] = slider.querySelectorAll(v[0])
  }
  // console.log(dom)

  // step back
  for (const item of slider.querySelectorAll('.back')) {
    item.addEventListener('click', () => {
      window.scrollTo({ top: sliderTop(), left: 0, behavior: 'smooth' })
      slider.dispatchEvent(new Event('prev'))
    })
  }

  // step 1: meetings
  // dom.lieu.addEventListener('input', loadMeetings)
  dom.meetingList.addEventListener('click', (e) => {
    const target = e.target.closest('.vp-link')
    if (target) {
      const id = target.dataset.id
      dom.meetingId.value = id
      // for (const item of dom.meetingSelects) {
      //   item.value = id
      // }
      updateOk(target)
      goto(dom.step2)
    }
  })
  dom.meetingInternationalList.addEventListener('click', (e) => {
    const target = e.target.closest('.vp-link')
    if (target) {
      const id = target.dataset.id
      dom.meetingId.value = id
      // for (const item of dom.meetingSelects) {
      //   item.value = id
      // }
      updateOk(target)
      goto(dom.step2)
    }
  })
  // for (const item of dom.meetingSelects) {
  //   item.addEventListener('input', (e) => {
  //     const id = e.target.value
  //     dom.meetingId.value = id
  //     for (const item of dom.meetingSelects) {
  //       if (e.target !== item) item.value = id
  //     }
  //     updateOk(id)
  //   })
  // }
  dom.process2.addEventListener('click', step2)
  dom.process3.addEventListener('click', step3)

  // background-color handler + scroll to slider top on slide
  slider.addEventListener('navigate', (e) => {
    const current = e.detail.current || null
    slider.classList.toggle('black', [dom.step1].includes(current))
    window.scrollTo({ top: sliderTop(), left: 0, behavior: 'smooth' })
  })

  // init inputs
  dom.email.value = ''
  dom.tel.value = ''
  dom.nom.value = ''
  dom.prenom.value = ''
  dom.cp.value = ''
  dom.pays.value = ''
  dom.statut.value = ''
  dom.connus.value = ''
  dom.rgpd.checked = false
  dom.newom.checked = true
  dom.newsletter.checked = true

  slider.dispatchEvent(new Event('refresh'))
  loadMeetings()
}

async function loadMeetings() {
  dom.meetingList.classList.add('disabled')

  dom.step2.dataset.status = 'hidden'
  dom.step3.dataset.status = 'hidden'
  dom.step4.dataset.status = 'hidden'
  slider.dispatchEvent(new Event('refresh'))

  // meetings url
  const url = new URL(slider.dataset.url)
  url.searchParams.set('action', slider.dataset.action)
  url.searchParams.set('nonce', slider.dataset.nonce)
  url.searchParams.set('step', 'meetings')
  let response

  try {
    response = await fetch(url)
  } catch (error) {
    dom.serverMessage.innerHTML = 'Pas de réseau disponible'
    return
  }

  // http error
  if (!response.ok) {
    dom.serverMessage.innerHTML = `Une erreur est survenue (${response.status} ${response.statusText})`
    return
  }

  const json = await response.json()
  // console.log(json)

  // api error
  if (json.data.odoo_error) {
    dom.serverMessage.innerHTML =
      "Une erreur est survenue lors de l'appel à l'api de données."
    return
  }

  if (json.data.meetings !== '') {
    dom.meetingList.innerHTML = json.data.meetings
    for (const el of dom.meetingListAll) {
      el.classList.remove('hidden')
    }
  } else {
    for (const el of dom.meetingListAll) {
      el.classList.add('hidden')
    }
  }

  if (json.data.meetings_international !== '') {
    dom.meetingInternationalList.innerHTML = json.data.meetings_international
    for (const el of dom.meetingInternationalListAll) {
      el.classList.remove('hidden')
    }
  } else {
    for (const el of dom.meetingInternationalListAll) {
      el.classList.add('hidden')
    }
  }

  dom.meetingList.classList.remove('disabled')
}

async function step2() {
  dom.serverMessage.innerHTML = ''
  if (!validate(dom.step2)) return

  const process = dom.process2
  const message = dom.step2.querySelector('.message')

  // meetings url
  const url = new URL(slider.dataset.url)
  url.searchParams.set('action', slider.dataset.action)
  url.searchParams.set('nonce', slider.dataset.nonce)
  url.searchParams.set('step', 'contact')

  // start loading
  process.innerHTML = `<span>${process.dataset.loading}<span>${process.dataset.loading}</span></span>`
  process.disabled = true
  await wait(ajaxWait)
  let response, serverMessage

  // send
  try {
    response = await fetch(url)
  } catch (error) {
    serverMessage.innerHTML = 'Pas de réseau disponible'
    return
  }

  // end loading
  process.innerHTML = `<span>${process.dataset.label}<span>${process.dataset.label}</span></span>`
  process.disabled = false

  // http error
  if (!response.ok) {
    switch (response.status) {
      case 400:
        validate(dom.step2)
        break
      default:
        serverMessage.innerHTML = `Une erreur est survenue (${response.status} ${response.statusText})`
        break
    }
    return
  }

  const json = await response.json()
  // console.log(json)

  // api error
  message.innerHTML = json.data.message || ''
  dom.step3.querySelector('.message').innerHTML = json.data.message || ''
  if (json.data.odoo_error) {
    serverMessage.innerHTML =
      "Une erreur est survenue lors de l'appel à l'api de données."
    return
  }

  // statuts
  if (json.data.autre_statuts) {
    dom.statut.innerHTML = '<option value=""></option>'
    for (const item of json.data.autre_statuts) {
      dom.statut.innerHTML += `<option value="${item.id}">${item.nom}</option`
    }
  }

  // connus
  if (json.data.connus) {
    dom.connus.closest('.field').style.display = 'flex'
    dom.connus.innerHTML = '<option value=""></option>'
    for (const item of json.data.connus) {
      dom.connus.innerHTML += `<option value="${item.id}">${item.nom}</option`
    }
    dom.connus.value = json.data.contact?.connu?.id || ''
  } else {
    dom.connus.closest('.field').style.display = 'none'
  }

  // contact
  if (json.data.next) {
    goto(dom.step3)
  } else {
    dom.step3.dataset.status = 'hidden'
    dom.step4.dataset.status = 'hidden'
    slider.dispatchEvent(new Event('refresh'))
  }
}

async function step3() {
  dom.serverMessage.innerHTML = ''
  if (!validate(dom.step3)) return
  if (!validate(dom.step1)) return
  if (!validate(dom.step2)) return

  const process = dom.process3
  // const message = dom.step3.querySelector('.message')

  // meetings url
  const url = new URL(slider.dataset.url)
  url.searchParams.set('action', slider.dataset.action)
  url.searchParams.set('nonce', slider.dataset.nonce)
  url.searchParams.set('step', 'send')
  url.searchParams.set('meeting_id', dom.meetingId.value)
  url.searchParams.set('email', dom.email.value)
  url.searchParams.set('tel', dom.tel.value)
  url.searchParams.set('nom', dom.nom.value)
  url.searchParams.set('prenom', dom.prenom.value)
  url.searchParams.set('cp', dom.cp.value)
  url.searchParams.set('pays', dom.pays.value)
  url.searchParams.set('autre_statut', dom.statut.value)
  url.searchParams.set('rgpd', dom.rgpd.checked ? '1' : '0')
  url.searchParams.set('newom', dom.newom.checked ? '1' : '0')
  url.searchParams.set('newsletter', dom.newsletter.checked ? '1' : '0')
  if (dom.connus.closest('.field').style.display !== 'none') {
    url.searchParams.set('connus', dom.connus.value)
  }

  // start loading
  process.innerHTML = `<span>${process.dataset.loading}<span>${process.dataset.loading}</span></span>`
  process.disabled = true
  await wait(ajaxWait)
  let response

  // send
  try {
    response = await fetch(url)
    process.disabled = false
  } catch (error) {
    process.disabled = false
    dom.serverMessage.innerHTML = 'Pas de réseau disponible'
    return
  }

  // end loading
  process.innerHTML = `<span>${process.dataset.label}<span>${process.dataset.label}</span></span>`
  let json

  // http error
  if (!response.ok) {
    switch (response.status) {
      case 400:
        json = await response.json()
        // console.log(json)
        dom.serverMessage.innerHTML = `Une erreur est survenue (${response.status} ${response.statusText})`
        break
      default:
        dom.serverMessage.innerHTML = `Une erreur est survenue (${response.status} ${response.statusText})`
        break
    }
    return
  }

  json = await response.json()
  // console.log(json)

  // api error
  if (json.data.odoo_error) {
    dom.serverMessage.innerHTML =
      "Une erreur est survenue lors de l'appel à l'api de données."
    return
  }

  if (!json.data.response.valid) {
    if (json.data.response.errors?.length > 0) {
      const lines = json.data.response.errors.map((el) => `<div>${el}</div>`)
      dom.serverMessage.innerHTML = lines.join('')
    }
  } else {
    dom.step1.dataset.status = 'hidden'
    dom.step2.dataset.status = 'hidden'
    dom.step3.dataset.status = 'hidden'
    goto(dom.step4)
  }
}

function validate(step) {
  switch (step) {
    case dom.step1:
      for (const item of ['meetingId']) {
        if (!dom[item].checkValidity()) {
          dom.serverMessage.innerHTML = dom[item].dataset.error || 'erreur'
          goto(step)
          return false
        }
      }
      break

    case dom.step2:
      for (const item of ['email', 'tel', 'nom', 'prenom', 'cp', 'pays']) {
        if (!dom[item].checkValidity()) {
          dom.serverMessage.innerHTML = dom[item].dataset.error || 'erreur'
          dom[item].focus()
          dom[item].select()
          goto(step)
          return false
        }
      }
      break

    case dom.step3:
      if (dom.statut.value === '') {
        dom.serverMessage.innerHTML = dom.statut.dataset.error || 'erreur'
        dom.statut.focus()
        goto(step)
        return false
      }
      if (dom.connus.value === '') {
        dom.serverMessage.innerHTML = dom.connus.dataset.error || 'erreur'
        dom.connus.focus()
        goto(step)
        return false
      }
      if (!dom.rgpd.checked) {
        dom.serverMessage.innerHTML = dom.rgpd.dataset.error || 'erreur'
        goto(step)
        return false
      }
      break
  }

  return true
}

function goto(step) {
  step.dataset.status = ''
  step.dispatchEvent(new Event('navigate'))
}

function sliderTop() {
  return (
    Math.ceil(slider.getBoundingClientRect().top) +
    document.documentElement.scrollTop -
    parseInt(getComputedStyle(slider).getPropertyValue('scroll-margin-top'), 10)
  )
}

function updateOk(el) {
  const links = el.parentElement
  const meeting = links.previousElementSibling.previousElementSibling
  const dateEl = meeting.querySelector('.date')
  const date = dateEl.innerText
  dom.step4.querySelector('.recap').innerHTML = `${date}`
}
